import React, { useEffect, useRef } from 'react';
import './DAComponents.css';
import {Link} from 'react-router-dom';

const transformCards = [
  {
    icon: '/icons/tech.webp',
    title: 'Technological Innovation',
    desc: 'We leverage cutting-edge technologies such as artificial intelligence, machine learning, and cloud computing to drive innovation and enhance your business processes.',
  },
  {
    icon: '/logos/circle.webp',
    title: 'Agile Methodology',
    desc: 'We adopt an agile mindset, collaborating closely with your team to streamline development, shorten time-to-market, and enhance flexibility in meeting customer needs.',
  },
  {
    icon: '/icons/benefit2.webp',
    title: 'User-Centric Design',
    desc: 'We place a strong emphasis on understanding your users. Our UX/UI designers conduct in-depth research to uncover user needs and preferences.',
  },
  {
    icon: '/icons/benefit4.webp',
    title: 'Data-Driven Decision Making',
    desc: 'Data is at the heart of digital acceleration. Our data scientists help you harness the power of data by implementing advanced analytics and business intelligence solutions.',
  },
  {
    icon: '/icons/coins.webp',
    title: 'Scalable and Secure Infrastructure',
    desc: 'We ensure your digital solutions have a solid foundation, with our team architecting scalable, secure infrastructure. We implement robust security measures for data safety and compliance with industry standards.',
  },
];

const TransformSection = () => {
  const headingRef = useRef(null);
  const paraTopRef = useRef(null);
  const paraRightRef = useRef(null);
  const cardRefs = useRef([]);

  useEffect(() => {
    const observer = new IntersectionObserver(
      entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            entry.target.classList.add('visible');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.1 }
    );

    [headingRef.current, paraTopRef.current, paraRightRef.current, ...cardRefs.current].forEach(ref => {
      if (ref) observer.observe(ref);
    });

    return () => observer.disconnect();
  }, []);

  return (
    <section className="transform-section" id ="components">
      <div className="conatiner">
      <div className="transform-header">
        <h2 ref={headingRef}>
          KEY  <span className="blue"> COMPONENTS</span>
        </h2>
        <p className="para-rightsf" ref={paraRightRef}>
          Stay ahead of the ever-shifting landscape of digital acceleration. While competitors move faster than ever, we make you leap ahead.
        </p>
      </div>

      <p className="para-below" ref={paraTopRef}>
        We collaborate closely with your business to identify the key areas that will have the most significant impact on your growth, and help your scale-up or enterprise build resilience and unlock the true potential of new digital technologies.
      </p>

      <div className="transform-cards">
        {transformCards.map((card, idx) => (
          <div
            key={idx}
            className="transform-card fade-up"
            ref={el => cardRefs.current[idx] = el}
          >
            <img src={card.icon} alt="icon" className="transform-icon" />
            <h3 className="transform-title">{card.title}</h3>
            <p className="transform-desc">{card.desc}</p>
          </div>
        ))}
      </div>

      <div className="transform-button-wrapper">
        <Link to="/contact">
        <button className="transform-button">GET STARTED WITH YOUR DIGITAL TRANSFORMATION PROJECT</button>
        </Link>
      </div>
      </div>
    </section>
  );
};

export default TransformSection;
